import { render, staticRenderFns } from "./ImageMatchItem.vue?vue&type=template&id=973de270&scoped=true&"
import script from "./ImageMatchItem.vue?vue&type=script&lang=ts&"
export * from "./ImageMatchItem.vue?vue&type=script&lang=ts&"
import style0 from "./ImageMatchItem.vue?vue&type=style&index=0&id=973de270&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "973de270",
  null
  
)

export default component.exports